import { render, staticRenderFns } from "./admin-reports.vue?vue&type=template&id=70c55048&"
import script from "./admin-reports.vue?vue&type=script&lang=js&"
export * from "./admin-reports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports